import { currentRoom } from '../kamo-si-invite/api';
/**
 * TPENGAGE (owner 2026-10-28): "Kick out" on an SI's tile. Kamo Meet's Prosody never lets anyone kick the SI's bridge
 * leg (it is a server admin), so the kick is also sent to Kamo, as this signed-in member: the SI's stay ends, recorded
 * as a kick, and it is never dialled back in by itself. A guest has no session: nothing is sent (guests cannot kick).
 *
 * @param {string} memberId - The SI.
 * @returns {Promise<boolean>} Whether Kamo took it.
 */
export async function kickSi(memberId) {
    try {
        const res = await fetch(`/api/meet/si-invites/${encodeURIComponent(memberId)}?room=${encodeURIComponent(currentRoom())}`, {
            method: 'DELETE',
            credentials: 'include',
            headers: { Accept: 'application/json' }
        });
        return res.ok;
    }
    catch (e) {
        return false;
    }
}
